import React, { useEffect, useState } from 'react'
import CreateAccount from 'components/register/CreateAccount'
import ConfirmStore from './ConfirmStore'
import { orderTypes } from 'utils/appUtils'
import { setEnteredAddress } from 'modules/location/actions'
import { useDispatch } from 'react-redux'

export default function (props) {
    const selectedAddress = props.pickupAddress
    const dispatch = useDispatch()
    const [formState, setFormState] = useState(
        selectedAddress.type === orderTypes.PICKUP && selectedAddress.formatted_address ? 2 : 1
    )
    const nextForm = () => {
        setFormState(formState => formState + 1)
    }

    const prevForm = () => {
        setFormState(formState => formState - 1)
    }
    useEffect(() => {
        dispatch(setEnteredAddress(formState))
    }, [formState])

    switch (formState) {
        case 1:
        case 2: {
            return (
                <ConfirmStore
                    {...props}
                    nextForm={nextForm}
                    prevForm={prevForm}
                    formState={formState}
                    setShowDateTimePicker={props.setShowDateTimePicker}
                >
                    {props.children}
                </ConfirmStore>
            )
        }
        case 3: {
            return (
                <CreateAccount
                    {...props}
                    nextForm={nextForm}
                    prevForm={prevForm}
                    hide={props.hide}
                ></CreateAccount>
            )
        }
        default:
            return
    }
}
